import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const PhotoUploadOptionSection = ({
  productCheckNotice,
}: {
  productCheckNotice: string | null;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.photo_upload_option")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t(
            "quest_detail.field.photo_upload_option.product_check_notice",
          ),
          children: (
            <Typography color="text.secondary">
              {productCheckNotice ?? ""}
            </Typography>
          ),
        },
      ]}
    />
  );
};

export default PhotoUploadOptionSection;
